import { createElement, memo } from '@max/max';
import Image from '@hfe/max-image';
import View from '@hfe/max-view';
import ImageBackground from '@hfe/max-imagebackground';
import Sensor from '@max/mbc-sensor';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import { CARD_MC, CARD_MV, POS_ICON } from '../../utils/constant';
import { formatDiscount, formatPrice, getLocString } from '../../utils/utils';
import { venusParams } from '../../utils/formatImage';
// import { navigateTo } from '@max/meituan-uni-navigate';
import navigateToPage from '../../utils/jump';
import { getSystemType } from '@nibfe/mkt-env-api';
const isWeb = true;
const isMRN = false;
const MyComponent = (props) => {
    var _a, _b, _c, _d, _e;
    const { isQueryTag, isShowChoiceness, customTagConfig, dealText, index, _LXReport, menuId, item, channelId } = props;
    const { mvReport, mcReportWithTag } = _LXReport;
    const isIOS = getSystemType().toLowerCase() === 'ios';
    const isAndroid = getSystemType().toLowerCase() === 'android';
    function handleBuy() {
        mcReportWithTag && mcReportWithTag(CARD_MC, {
            valLab: {
                deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                instance_id: menuId,
                item_index: index,
                poi_id: item === null || item === void 0 ? void 0 : item.poiId
            }
        });
        navigateToPage(item === null || item === void 0 ? void 0 : item.dealJumpLink, item === null || item === void 0 ? void 0 : item.dealId, channelId);
    }
    const caleFontSize = (str) => {
        const integer = str.split('.')[0];
        if (integer.length < 4) {
            return '36rpx';
        }
        else if (integer.length === 4) {
            return '34rpx';
        }
        else {
            return '26rpx';
        }
    };
    const isShowCustomTag = isShowChoiceness === 1 && (customTagConfig === null || customTagConfig === void 0 ? void 0 : customTagConfig.customTagCount) > 0 && index <= (customTagConfig === null || customTagConfig === void 0 ? void 0 : customTagConfig.customTagCount) - 1;
    return <Sensor onAppear={() => {
        mvReport && mvReport(CARD_MV, {
            valLab: {
                deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                instance_id: menuId,
                item_index: index
            }
        });
    }}>
            <View className="three-card-container" onClick={handleBuy}>
                <View className="three-card-image-view">
                    {isQueryTag === 1 && isShowCustomTag && <View className="three-card-custom-tag-view">
                            <ImageBackground source={{
        uri: customTagConfig.customTagBgUrl,
        width: 104,
        height: 32
    }} className="three-card-custom-tag-bg">
                                <Text className="three-card-custom-tag-text">{customTagConfig.customTagText}</Text>
                            </ImageBackground>
                        </View>}
                    {isQueryTag === 2 && ((_a = item === null || item === void 0 ? void 0 : item.dealSubscriptVOList) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = item === null || item === void 0 ? void 0 : item.dealSubscriptVOList[0]) === null || _b === void 0 ? void 0 : _b.picUrl) ? <View className="three-card-custom-tag-view">
                            <Image source={{
        uri: ((_c = item === null || item === void 0 ? void 0 : item.dealSubscriptVOList[0]) === null || _c === void 0 ? void 0 : _c.picUrl) || '',
        width: 104,
        height: 32
    }} className="three-card-custom-tag-bg"/>
                        </View> : <></>}
                    <Image className="three-card-image" source={{
        uri: venusParams(item === null || item === void 0 ? void 0 : item.frontImg, 226, 170)
    }} resizeMode="cover" onLongpress={e => {
        e.preventDefault();
    }}/>
                    <LinearGradient className="three-card-image-shadow" start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} colors={['rgba(0,0,0,0.00)', '#000000']}/>
                    <View className="three-card-pos">
                        <Image className="three-card-pos-icon" source={{
        uri: POS_ICON
    }}/>
                        <Text className="three-card-pos-text">{getLocString(item === null || item === void 0 ? void 0 : item.dealLocateInfo)}</Text>
                    </View>
                </View>
                <View className="three-card-deal-title-view">
                    <Text className="three-card-deal-title" numberOfLines={2}>{item === null || item === void 0 ? void 0 : item.dealName}</Text>
                </View>
                <View className="three-card-tag-field">
                    {!!(item === null || item === void 0 ? void 0 : item.discountRate) && (item === null || item === void 0 ? void 0 : item.discountRate) !== '0.0' && (item === null || item === void 0 ? void 0 : item.discountRate) !== '10.0' && <View className="three-card-sale-tag">
                            <Text className="three-card-sale-text">{formatDiscount(item === null || item === void 0 ? void 0 : item.discountRate)}折</Text>
                        </View>}
                    {(_e = (_d = item === null || item === void 0 ? void 0 : item.dealSaleTags) === null || _d === void 0 ? void 0 : _d.filter((tagItem) => (tagItem === null || tagItem === void 0 ? void 0 : tagItem.tagType) === 2)) === null || _e === void 0 ? void 0 : _e.map((tags) => {
        return <View className="three-card-sale-tag">
                                <Text className="three-card-sale-text" style={{
            color: tags === null || tags === void 0 ? void 0 : tags.color
        }}>{tags === null || tags === void 0 ? void 0 : tags.title}</Text>
                            </View>;
    })}
                </View>
                <View className="three-card-bottom-field" style={{
        alignItems: !!(item === null || item === void 0 ? void 0 : item.originalPrice) && (item === null || item === void 0 ? void 0 : item.price) !== (item === null || item === void 0 ? void 0 : item.originalPrice) ? "center" : "center"
    }}>
                    <View className="three-card-bottom-field-container">
                        {!!(item === null || item === void 0 ? void 0 : item.originalPrice) && (item === null || item === void 0 ? void 0 : item.price) !== (item === null || item === void 0 ? void 0 : item.originalPrice) ? <View className="three-card-price-field">
                                    <View className="three-card-price">
                                        <View className="three-card-price-sale-price">
                                            <View style={{
        marginTop: '4rpx'
    }}><Text className="three-card-price-unit">¥</Text></View>
                                            <Text className="three-card-price-number" style={{
        fontSize: caleFontSize(formatPrice(item === null || item === void 0 ? void 0 : item.price))
    }}>{formatPrice(item === null || item === void 0 ? void 0 : item.price)}</Text>
                                        </View>
                                        <View style={{
        height: '40rpx',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '12rpx',
        paddingBottom: isWeb ? 0 : isAndroid ? '3rpx' : 0
    }}>
                                            <Text className="three-card-price-start">起</Text>
                                        </View>
                                    </View>
                                    <View className="three-card-origin-price-content" style={{
        marginTop: isWeb || !isIOS ? ' -6rpx' : '-2rpx'
    }}>
                                        <View>
                                            <Text className="three-card-origin-price">¥{formatPrice(item === null || item === void 0 ? void 0 : item.originalPrice)}</Text>
                                        </View>
                                    </View>
                                </View> : <View className="three-card-price" style={{
        height: '60rpx',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }}>
                                    <View className="three-card-price-sale-price">
                                        <View style={{
        marginTop: '4rpx'
    }}><Text className="three-card-price-unit">¥</Text></View>
                                        <Text className="three-card-price-number" style={{
        fontSize: caleFontSize(formatPrice(item === null || item === void 0 ? void 0 : item.price))
    }}>{formatPrice(item === null || item === void 0 ? void 0 : item.price)}</Text>
                                    </View>
                                    <View style={{
        height: '40rpx',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '12rpx',
        paddingBottom: isWeb ? 0 : isAndroid ? '3rpx' : 0
    }}>
                                        <Text className="three-card-price-start">起</Text>
                                    </View>
                                </View>}

                        <View className="three-card-btn-container">
                            <LinearGradient className="three-card-btn" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 1
    }} colors={['#FF7700', '#FF4B10']}>
                                <Text className="three-card-btn-text">{dealText}</Text>
                            </LinearGradient>
                        </View>
                    </View>
                </View>
            </View>
        </Sensor>;
};
export default memo(MyComponent);
